var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto pa-6 mr-2",attrs:{"elevation":6}},[(_vm.loading)?_c('grafico-pizza',{attrs:{"id":_vm.id,"category-field":_vm.categoria,"value-fields":_vm.valueFields,"dados":_vm.dados,"title":_vm.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }